<template>
    
    <form
        id="enquire_form"
        @submit.prevent="submit"
        method="post"
        :class="{'success' : success}"
        class="full">
        <div v-if="success" class="message-sent">
            <img alt="Vue logo" src="../assets/Logo-9T-Thick-White.svg">
            <h2>Thank you for your enquiry</h2>
            <p>A member of our team will be in touch shortly.</p>
            <button type="submit" class="bordered" @click="reloadForm">Send another enquiry</button>
        </div>

        <span v-if="success" id="form-body"></span>  
        <span v-else id="form-body">
           
            <!-- Google tag manager GCLID offline tracking managed by luux-media.com -->
            <input data-drupal-selector="edit-gclid" type="hidden" name="utm_gclid" value="">
            <input data-drupal-selector="edit-utm-source" type="hidden" name="utm_source" value="">
            <input data-drupal-selector="edit-utm-medium" type="hidden" name="utm_medium" value="">
            <input data-drupal-selector="edit-utm-campaign" type="hidden" name="utm_campaign" value="">
            <input data-drupal-selector="edit-utm-content" type="hidden" name="utm_content" value="">
            <input data-drupal-selector="edit-utm-term" type="hidden" name="utm_term" value="">

            <input type="hidden" name="_token" :value="csrf">
            <div class="grid-container form-enquiry">  
                <div class="input-wrapper name">
                    <label for="name">Name</label>
                    <input
                        required
                        type="text"
                        id="name"
                        class=""
                        name="name"
                        v-model="userData.name">
                </div>
                <div class="input-wrapper email">
                    <label for="email">Email</label>
                    <input      
                        required          
                        type="email"
                        id="email"
                        size="35"
                        name="email"
                        v-model="userData.email">
                </div>
                <div class="input-wrapper phone">
                    <label for="phone">Telephone</label>
                    <input
                        required
                        type="text"
                        id="phone"
                        class=""
                        name="phone"
                        v-model="userData.phone"
                        @input="validatePhoneNumber">
                        <div v-if="phoneValidationMessage.message"><small class="inform-tip-message">{{ phoneValidationMessage.message }}</small></div>
                </div>
                <div class="input-wrapper message">
                    <label for="message">Message</label>
                    <textarea required style="height: 90px;" type="message" v-model="userData.message" class="form-control" rows="4" cols="100" 
                     name="message" id="message"></textarea>
                     <div class="inform-tip-message" v-if="!isMessageValid">Minimum 10 characters required</div>
                </div>
                <div class="input-wrapper privacy">      
                    <span class="privacy">
                        <label class="checkbox-container">
                            <input required type="checkbox" v-model="userData.privacy" name="privacy" value="Agreed" id="privacy" >
                            <span class="checkmark"></span>    
                        </label>
                        <span>
                        The personal information you provide will be used exclusively to process your request.
                        <br>We won't share your information with third parties.
                        <br>We will not disclose any information to other organisations unless we are required by law to do so or to prevent fraud.</span>
                    </span>
                </div>
            </div>

            <button :disabled="!isMessageValid || !phoneValidationMessage.valid" :class="{ 'disabled-button': !isMessageValid || !phoneValidationMessage.valid}" id="contact-submit" class="bordered" type="submit">Send</button><br>

        </span>
    </form>
</template>

<script>
import Vue from 'vue'
import ReCaptcha from '../components/ReCaptcha.vue'
export default {
    name: 'EnquiryForm',
    // components: {
    //     ReCaptcha
    // },
        props: {
        Model: {},
        SKU: {},
        formOrigin: {},
   },
    data() {
        let currentUrl = window.location.href;
        return {
            currentUrl: currentUrl, // Add currentUrl to data
            validatePhoneNumber: '',
            userData: {
                form_url: currentUrl,
                form_origin: this.formOrigin,
                model: this.Model,
                sku: this.SKU,
                name: '',
                email: '',
                phone: '' ,
                message: '',
                privacy: []
            },
            errors: {},
            success: false,
            loaded: true,
            csrf: document.head.querySelector('meta[name="csrf-token"]').content,
        } 
    },
    watch: {
        '$route'(to, from) {
            this.currentUrl = window.location.href; // Update currentUrl when route changes
        }
    },
    computed: {
        phoneValidationMessage() {
            if (this.userData.phone.length > 0) {
                return this.phoneValidation(message);
            }
            return ''; // Return an empty string if no input is provided
        },
        showMergeTooltip () {
            return this.userData.value[1] - this.userData.value[0] < 10000
        },
        isMessageValid() {
            return this.userData.message.length >= 10;
        },
    },
    methods: {
  
        phoneValidation() {
            const phoneRegex = /^(\+[0-9]+|00[0-9]+)$/; // Regular expression for country code starting with + or 00 followed by numbers
            const numberRegex = /^[0-9+]+$/; // Regular expression for numbers only

            if (this.userData.phone.length > 0) {
                if (numberRegex.test(this.userData.phone)) {
                    if (phoneRegex.test(this.userData.phone)) {
                        return { valid: true, message: '' };
                    } else {
                        return { valid: false, message: 'Invalid phone number. Please provide your country code. e.g. +44 or 0044' };
                    }
                } else {
                    return { valid: false, message: 'Only numbers allowed' };
                }
            } else {
                return { valid: false, message: '' };
            }
        },

        submit() {
            if (this.loaded) {
            this.loaded = false;
            this.success = false;
            this.errors = {};
             this.$axios.post('/submit', this.userData ).then(response => {
                this.userData.form_origin = '';
                this.userData.name = '';
                this.userData.email = '';
                this.userData.phone = '';
                this.userData.model = '';
                this.userData.sku = '';
                this.userData.message = '';
                this.userData.form_url = '';
                this.userData.privacy = [];
                this.loaded = true;
                this.success = true;
                window.scrollTo(0,0);
            }).catch(error => {
              if (error.response.status === 422) {
                  this.errors = error.response.data.errors || {};
                  }
            });
            }
        },
        reloadForm() {
            this.errors = {};
            this.success = false;
            this.loaded = true;
            this.userData.form_origin = this.formOrigin; // Reset form_origin to its initial value
            this.userData.form_url = this.currentUrl; // Reset form_url to its initial value
            this.userData.model = this.Model; // Reset model to its initial value
            this.userData.sku = this.SKU; // Reset sku to its initial value
            // this.$forceUpdate();     
          }
      },
 
    }
</script>